export const APPLY = 'casino-heroes/limits/APPLY'
export const CANCEL = 'casino-heroes/limits/CANCEL'
export const CLEAR = 'casino-heroes/limits/CLEAR'
export const EDIT = 'casino-heroes/limits/EDIT'
export const INIT = 'casino-heroes/limits/INIT'
export const REMOVE = 'casino-heroes/limits/REMOVE'
export const SET = 'casino-heroes/limits/SET'
